import { createAsyncThunk } from '@reduxjs/toolkit';
import { briefingsService } from '../../services/briefings.service';
import {
  GetBriefingsRequest,
  CreateBriefingRequest,
  UpdateBriefingRequest,
} from '@/types/briefings';

export const briefings = {
  getBriefings: createAsyncThunk(
    'briefings/getBriefings',
    async (params: GetBriefingsRequest | undefined, { rejectWithValue }) => {
      try {
        const response = await briefingsService.getBriefings(params);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch briefings');
      }
    }
  ),

  getBriefingById: createAsyncThunk(
    'briefings/getBriefingById',
    async (briefingId: string, { rejectWithValue }) => {
      try {
        const response = await briefingsService.getBriefingById(briefingId);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch briefing');
      }
    }
  ),

  createBriefing: createAsyncThunk(
    'briefings/createBriefing',
    async (briefingData: CreateBriefingRequest, { rejectWithValue }) => {
      try {
        const response = await briefingsService.createBriefing(briefingData);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to create briefing');
      }
    }
  ),

  updateBriefing: createAsyncThunk(
    'briefings/updateBriefing',
    async (briefingData: UpdateBriefingRequest, { rejectWithValue }) => {
      try {
        const response = await briefingsService.updateBriefing(briefingData);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to update briefing');
      }
    }
  ),
};
